import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { messagingGroupsApi } from '~/apis/messagingGroupsApi'
import { useUserState } from '~/atoms/UserState'
import { toaster } from '~/components/ui/toaster'
import { useCheckRole } from '~/hooks/useCheckRole'
import { ApplicationRoutes } from '~/types/RoutingTypes'
import { getApiEnvironment } from '~/utils/common'

import { MessagingDetailPage } from '@mangovoice/messaging-ui'

export const MessagingGroupDetailPage = () => {
  const { t } = useTranslation()
  const { groupId } = useParams<{ groupId: string }>()
  const { pbxId } = useUserState({ canAutoRefresh: false })
  const checkRole = useCheckRole()

  // Mirror legacy admin's `user_can(..., MESSAGING, can_edit)` gate, which is
  // granted to any Administrator-level user (and Mango staff). `checkRole`
  // short-circuits to `true` for Mango staff / superusers, so a single
  // `checkRole('admin')` captures both the Administrator-and-up rule and the
  // internal-staff override. Create and delete are gated on the list page
  // and restricted there to internal staff only.
  const canEdit = checkRole('admin')

  const parsedGroupId = groupId ? parseInt(groupId, 10) : NaN
  const groupIdNum = Number.isNaN(parsedGroupId) ? undefined : parsedGroupId

  if (!pbxId || !groupIdNum) {
    return null
  }

  return (
    <MessagingDetailPage
      api={messagingGroupsApi}
      pbxId={pbxId}
      groupId={groupIdNum}
      toast={toaster}
      t={t}
      campaignIdRequired={getApiEnvironment() !== 'production_uk'}
      listPath={ApplicationRoutes.MESSAGING_GROUPS}
      canEdit={canEdit}
      canManageMembers={canEdit}
    />
  )
}
